export default function getSelectedLanguage(state) {
  return state.supportedLanguage;
}
